import { BrandName, useBrandConfig } from '@40seas/frontend/libs/providers';
import { Icon40SeasLoader } from './40seasLoader';
import { IconReevolLoader } from './reevolLoader';

export const BrandLoader = (props: { width?: number }) => {
    const brandConfig = useBrandConfig();

    if (brandConfig.name === BrandName.Reevol) {
        return <IconReevolLoader {...props} />;
    }

    return <Icon40SeasLoader {...props} />;
};
